/** ISO 3166-1 alpha-2 country codes to display names */
export const COUNTRY_NAMES: Record<string, string> = {
  AE: "United Arab Emirates",
  AR: "Argentina",
  AT: "Austria",
  AU: "Australia",
  BB: "Barbados",
  BE: "Belgium",
  BO: "Bolivia",
  BR: "Brazil",
  BS: "Bahamas",
  BW: "Botswana",
  BZ: "Belize",
  CA: "Canada",
  CH: "Switzerland",
  CL: "Chile",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CW: "Curaçao",
  CZ: "Czechia",
  DE: "Germany",
  DK: "Denmark",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EE: "Estonia",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FO: "Faroe Islands",
  FR: "France",
  GB: "United Kingdom",
  GH: "Ghana",
  GR: "Greece",
  GT: "Guatemala",
  GY: "Guyana",
  HN: "Honduras",
  HR: "Croatia",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IN: "India",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KH: "Cambodia",
  KR: "South Korea",
  LA: "Laos",
  LK: "Sri Lanka",
  LT: "Lithuania",
  LV: "Latvia",
  MA: "Morocco",
  MN: "Mongolia",
  MG: "Madagascar",
  MM: "Myanmar",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  OM: "Oman",
  NP: "Nepal",
  NZ: "New Zealand",
  PA: "Panama",
  PE: "Peru",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PL: "Poland",
  PR: "Puerto Rico",
  PT: "Portugal",
  PY: "Paraguay",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  SA: "Saudi Arabia",
  SE: "Sweden",
  SG: "Singapore",
  SN: "Senegal",
  SV: "El Salvador",
  TH: "Thailand",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad & Tobago",
  TW: "Taiwan",
  TZ: "Tanzania",
  UG: "Uganda",
  UY: "Uruguay",
  US: "United States",
  UZ: "Uzbekistan",
  VE: "Venezuela",
  VN: "Vietnam",
  ZA: "South Africa",
};

/** Continent to country code groupings */
export const CONTINENT_COUNTRIES: Record<string, string[]> = {
  "Americas": ["AR", "BB", "BO", "BR", "BS", "BZ", "CA", "CL", "CO", "CR", "CU", "CW", "DO", "EC", "GT", "GY", "HN", "JM", "MX", "NI", "PA", "PE", "PR", "PY", "SV", "TT", "US", "UY", "VE"],
  "Europe": ["AT", "BE", "CH", "CZ", "DE", "DK", "EE", "ES", "FI", "FO", "FR", "GB", "GR", "HR", "HU", "IE", "IS", "IT", "LT", "LV", "NL", "NO", "PL", "PT", "RO", "RS", "RU", "SE"],
  "Asia": ["AE", "CN", "ID", "IL", "IN", "IR", "JO", "JP", "KH", "KR", "LA", "LK", "MM", "MN", "MY", "NP", "OM", "PH", "SA", "SG", "TH", "TR", "TW", "UZ", "VN"],
  "Africa": ["BW", "ET", "GH", "KE", "MA", "MZ", "NA", "NG", "SN", "TZ", "UG", "ZA"],
  "Oceania": ["AU", "FJ", "NZ", "PG", "TO"],
};
